import React, {Component} from 'react'

class SkillLevel extends Component {
  render() {
    let stars = '';
    switch(this.props.skillLevel) {
      case 'Beginner':
        stars = '★☆☆☆☆';
        break;
      case 'Basic':
        stars = '★★☆☆☆';
        break;
      case 'Experienced':
        stars = '★★★☆☆';
        break;
      case 'Advanced':
        stars = '★★★★☆';
        break;
      case 'Professional':
        stars = '★★★★★';
        break;
    }

    return (
      <span title={this.props.skillLevel}>
        {stars}
      </span>
    );
  }
}

export default SkillLevel